import React from "react";

const SvgN = props => (
  <svg
    style={{
      isolation: "isolate"
    }}
    viewBox="0 0 205 200"
    {...props}
  >
    <defs>
      <clipPath id="N_svg__a">
        <path d="M0 0h205v200H0z" />
      </clipPath>
    </defs>
    <g clipPath="url(#N_svg__a)">
      <path
        d="M177.05 171v23.21h-2.63v-33.24l13.5 23.88V161.6h2.64v33.23L177.05 171z"
        fill="#1D1D1B"
      />
    </g>
  </svg>
);

export default SvgN;